

// Imports ---------------------------------------------------------------------

// Nuxt / Vendor
import Vue from "vue";

// Project
import { ContentNode } from "~/libs/Types";
import ContentGateway, { QuerySort } from "~/libs/ContentGateway";
import TeaserItem from "~/components/Teasers/Item.vue";

// Export ----------------------------------------------------------------------

export default Vue.extend({

    // Component imports -------------------------------------------------------

    components: {
        TeaserItem
    },

    // Component Properties ----------------------------------------------------

    props: {
        title: {
            type: String,
            required: false,
            default: ""
        },

        type: {
            type: String,
            required: true
        }
    },

    // Component Internal Data State -------------------------------------------

    data: () => ({
        nodes: [] as Array<ContentNode>
    }),

    // Nuxt/Vue Hooks ----------------------------------------------------------

    async fetch () {
        const sortBy = { field: "sequence", direction: "desc" } as QuerySort;

        this.nodes = await ContentGateway
            .make(this.$nuxt.context)
            .getNodeList(this.type, sortBy);
    },

    // Component Computed Properties -------------------------------------------

    computed: {
        hasItems (): boolean {
            return this.nodes.length > 0;
        },

        items (): ContentNode[] {
            return this.nodes.filter(item => item.slug !== "index");
        }
    }

    // -------------------------------------------------------------------------
});

